import React from 'react'
import {useTranslation} from 'react-i18next'
import classNames from 'classnames'
import {Pagination as AntPagination, Typography} from 'antd'
import {PageSizeSelect} from '@/components/dumb/Pagination/index'
import {Icon} from '@/components'
import {PaginationProps} from './props'
import styles from './styles.scss'
import {useScreenType} from '@/hooks'
import {NEXT_PAGE, PREVIOUS_PAGE} from '@/constants/playwright-ids'

const {Text} = Typography

export const Pagination: React.FC<PaginationProps> = ({
    className,
    current,
    pageSize,
    total,
    hideSizeChanger,
    onPageSizeChange,
    ...rest
}) => {
    const {t} = useTranslation()

    const {isMobile, isTablet} = useScreenType()
    const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
        if (type === 'prev') {
            return (
                <Text className={styles.actions} data-test-id={PREVIOUS_PAGE}>
                    <Icon type={'back_arrow_with_tail'} />
                    {t('Pagination.previous')}
                </Text>
            )
        }
        if (type === 'next') {
            return (
                <Text className={styles.actions} data-test-id={NEXT_PAGE}>
                    {t('Pagination.next')}
                    <Icon type={'next'} />
                </Text>
            )
        }

        return originalElement
    }

    return (
        <div>
            {isMobile && !hideSizeChanger && (
                <div className={styles.sizeSelectMobile}>
                    <PageSizeSelect onChange={onPageSizeChange} pageSize={pageSize} total={total} />
                </div>
            )}

            <div className={styles.paginationContainer}>
                {!isMobile && !hideSizeChanger && (
                    <PageSizeSelect onChange={onPageSizeChange} pageSize={pageSize} total={total} />
                )}
                <AntPagination
                    {...rest}
                    total={total}
                    current={current}
                    pageSize={pageSize}
                    className={classNames(styles.pagination, className)}
                    itemRender={pageSize < total ? itemRender : () => <div>1</div>}
                    showSizeChanger={false}
                    showLessItems={isMobile || isTablet}
                    hideOnSinglePage
                    size={isMobile ? 'small' : 'default'}
                />
            </div>
        </div>
    )
}
